module.exports = __webpack_public_path__ + "images/154_1024.jpg";